import React from 'react';

// Dynamic status → color mapping (Section 15 of spec + user status architecture)
const APPT_STATUS_COLOR = {
  'Needs Scheduling': 'red',
  'Need Scheduling': 'red',
  'Requested': 'yellow',
  'Granted': 'green',
  'Approved': 'green',
  'Updated TMS': 'neutral',
  'Updated': 'neutral',
  'Change': 'orange',
};

// Load Info statuses
export const LOAD_STATUSES = ['Available', 'Booked', 'Dispatched', 'At the Shipper', 'In Transit', 'Delivered', 'Released'];
const LOAD_STATUS_COLOR = {
  'Available': 'purple',
  'Booked': 'yellow',
  'Dispatched': 'aqua',
  'At the Shipper': 'blue',
  'In Transit': 'green',
  'Delivered': 'yellow',
  'Released': 'white',
};

// Carrier Assignment statuses
export const CARRIER_STATUSES = ['Available', 'Setting Up', 'Covered', 'RC Sent', 'Verified', 'Change', 'Recovering'];
const CARRIER_STATUS_COLOR = {
  'Available': 'purple',
  'Setting Up': 'aqua',
  'Covered': 'green',
  'RC Sent': 'blue',
  'Verified': 'white',
  'Verify': 'white',
  'Change': 'orange',
  'Recovering': 'red',
};

// Carrier Assignment → Load Info automatic linkage ("Change" never touches Load Info)
export const CARRIER_TO_LOAD_STATUS = {
  'Available': 'Available', 'Setting Up': 'Available', 'Covered': 'Available',
  'RC Sent': 'Available', 'Recovering': 'Available', 'Verified': 'Booked',
};
// Once Load Info reaches In Transit, Carrier Assignment is locked (only "Change" allowed)
export const POST_TRANSIT_STATUSES = ['In Transit', 'Delivered', 'Released'];
export const CARRIER_CHANGE_ROLES = ['super_admin', 'admin', 'account_manager', 'operator'];
// Physical-progress helpers (mirror backend routes/load_status.py)
export const pickupDeparted = (load) => (load.stops || []).some(s => s.type === 'pickup' && s.actual_departure);
export const pickupArrived = (load) => (load.stops || []).some(s => s.type === 'pickup' && s.actual_arrival);
export const finalDelivered = (load) => { const d = (load.stops || []).filter(s => s.type === 'delivery'); return d.length > 0 && !!d[d.length - 1].actual_departure; };
export const deriveLoadStatus = (load) => finalDelivered(load) ? 'Delivered' : pickupDeparted(load) ? 'In Transit' : pickupArrived(load) ? 'At the Shipper' : load.carrier_id ? (load.dispatched_at ? 'Dispatched' : 'Booked') : 'Available';
// Loads considered "active" for tracking purposes
export const ACTIVE_LOAD_STATUSES = ['Booked', 'Dispatched', 'At the Shipper', 'In Transit'];

// Cross-Border (XB) statuses — active only when Load status is "In Transit"
export const XB_STATUSES = ['In Transit MX', 'At Border MX', 'At Border US', 'In Transit US', 'At Border CA', 'In Transit CA'];
const XB_STATUS_COLOR = {
  'In Transit MX': 'green',
  'At Border MX': 'lightgreen',
  'At Border US': 'lightblue',
  'In Transit US': 'blue',
  'At Border CA': 'lightred',
  'In Transit CA': 'red',
};

export const apptStatusColor = (status) => APPT_STATUS_COLOR[status] || 'neutral';
export const loadStatusColor = (status) => LOAD_STATUS_COLOR[status] || 'neutral';
export const carrierStatusColor = (status) => CARRIER_STATUS_COLOR[status] || 'neutral';
export const xbStatusColor = (status) => XB_STATUS_COLOR[status] || 'neutral';

export const StatusBar = ({ left, right, color = 'neutral', testId }) => (
  <div className={`lw-statusbar ${color}`} data-testid={testId}>
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>{left}</span>
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>{right}</span>
  </div>
);

// Compact select styled for use inside a StatusBar
export const StatusSelect = ({ value, options, onChange, testId, disabled = false, placeholder = 'Select...' }) => {
  const opts = value && !options.includes(value) ? [value, ...options] : options;
  return (
    <select
      className="lw-input"
      style={{ height: 24, maxWidth: 160, fontSize: 12, fontWeight: 700, opacity: disabled ? 0.5 : 1 }}
      value={value || ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      data-testid={testId}
    >
      {!value && <option value="">{placeholder}</option>}
      {opts.map(s => <option key={s} value={s}>{s}</option>)}
    </select>
  );
};
